import { render, staticRenderFns } from "./QuestionNoimgAbcd.vue?vue&type=template&id=4fcf9b38&"
import script from "./QuestionNoimgAbcd.vue?vue&type=script&lang=ts&"
export * from "./QuestionNoimgAbcd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports